import classNames from 'classnames';
import { noop } from 'lodash';
import React from 'react';
import styles from './Tag.module.scss';

const Tag = ({ name, selected = true, onClick = noop }) => (
  <span onClick={onClick} className={classNames(styles.tag, { [styles.notSelected]: !selected })}>#{name}</span>
);

export default Tag;